export default "__VITE_ASSET__CLOSqKJa__"